// Long Task API collector. Each entry is a task > 50ms that blocked the main
// thread; we emit one event per task. Long tasks are sampled (default 50%)
// because volume scales with page complexity.

import { observePerf, now } from '../safe.js';
import { EVENT_TYPES } from '../schema.js';
import { shouldSample } from '../config.js';

export function initLongTasks(viewIdProvider, emit) {
  observePerf('longtask', (entries) => {
    for (const lt of entries) {
      if (!shouldSample(EVENT_TYPES.LONG_TASK)) continue;
      emit({
        id: viewIdProvider() + ':lt:' + lt.startTime.toFixed(0),
        t: now(),
        tp: EVENT_TYPES.LONG_TASK,
        n: 'long_task',
        mv: lt.duration,
        mu: 'ms',
        mr: '',
        mnt: '',
        // attribution[0].name is the script container kind ('self','same-origin',
        // 'cross-origin'); useful for blaming third parties.
        dim: { lt_container: (lt.attribution && lt.attribution[0] && lt.attribution[0].name) || '' },
        met: { lt_start: lt.startTime }
      });
    }
  });
}
